import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { INICIO } from "../utils";

// Protege una ruta: exige usuario logueado y, opcionalmente, un tipo permitido.
// El tipo viaja en user.tipo (alumno | admisiones | ensombrado | admin | checkin).
// La seguridad real la hace el back (cada área de la API comprueba el tipo).
export default function PrivateRoute({ children, allowedRoles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.tipo)) {
    return <Navigate to={INICIO[user.tipo] || "/login"} replace />;
  }
  return children;
}
